import React from 'react';
import AdminRowIcon from '../../components/admin/AdminRowIcon';
import { mailOutline } from 'ionicons/icons';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonBadge,
  IonSpinner,
  IonText,
  IonSearchbar,
  IonSelect,
  IonSelectOption,
} from '@ionic/react';
import { useAdminEmails } from '../../../application/use-cases/admin/useAdminEmails';
import AdminListFooter from '../../components/admin/AdminListFooter';
import './Admin.css';

const typeLabels: Record<string, string> = {
  welcome: 'Bienvenida',
  password_reset: 'Reset de contraseña',
  contact_notification: 'Lead de contacto',
  device_shared: 'Dispositivo compartido',
  lot_shared: 'Lote compartido',
};

const AdminEmails: React.FC = () => {
  const { items: emails, total, query, setQuery, type, setType, loading, loadingMore, loadMore, error } = useAdminEmails();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/app/admin" />
          </IonButtons>
          <IonTitle>Emails enviados ({total.toLocaleString('es-AR')})</IonTitle>
        </IonToolbar>
        <IonToolbar>
          <IonSearchbar value={query} placeholder="Buscar por destinatario" onIonInput={(e) => setQuery(e.detail.value ?? '')} />
          <IonSelect
            slot="end"
            aria-label="Tipo de email"
            interface="popover"
            value={type ?? ''}
            onIonChange={(e) => setType(e.detail.value || null)}
            className="admin-filter-select"
          >
            <IonSelectOption value="">Todos</IonSelectOption>
            {Object.entries(typeLabels).map(([value, label]) => (
              <IonSelectOption key={value} value={value}>
                {label}
              </IonSelectOption>
            ))}
          </IonSelect>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {loading && (
          <div className="ion-text-center ion-padding">
            <IonSpinner color="primary" />
          </div>
        )}
        {error && (
          <IonText color="danger">
            <p className="ion-padding">{error}</p>
          </IonText>
        )}
        {!loading && emails.length === 0 && !error && !query && !type && (
          <IonText color="medium">
            <p className="ion-padding">
              Todavía no se registró ningún envío (o SMTP no está configurado en este ambiente).
            </p>
          </IonText>
        )}

        <IonList className="admin-list">
          {emails.map((email) => (
            <IonItem key={email.id} lines="full">
              <AdminRowIcon icon={mailOutline} tone={email.success ? 'green' : 'red'} />
              <IonLabel>
                <h2>{typeLabels[email.type] ?? email.type}</h2>
                <p>{email.toEmail}</p>
                <p className="admin-list-row-meta">
                  {new Date(email.createdAt).toLocaleString('es-AR')}
                  {email.error ? ` · ${email.error}` : ''}
                </p>
              </IonLabel>
              <IonBadge color={email.success ? 'success' : 'danger'}>{email.success ? 'OK' : 'Error'}</IonBadge>
            </IonItem>
          ))}
        </IonList>
        {!loading && <AdminListFooter shown={emails.length} total={total} loadingMore={loadingMore} onMore={loadMore} />}
      </IonContent>
    </IonPage>
  );
};

export default AdminEmails;
